import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

import { useAppDispatch } from "../../store/hooks";
import { dashboardAction } from "../../store/dashboard/dashboardSlice";
import { Product } from "../../util/Utils";
import { THEME } from "../../util/LookupConst";
import dayjs from "dayjs";

ChartJS.register(ArcElement, Tooltip, Legend);

export const options = {
  responsive: true,
  plugins: {
    display: true,
    legend: {
      labels: {
        usePointStyle: true,
        pointStyle: "circle",
      },
      boxWidth: 6,
      position: "bottom" as const,
    },
  },
};

/* kept for future reference */
export const data = {
  labels: ["Significant impact"],
  datasets: [
    {
      label: "# of Votes",
      data: [42, 19],
      backgroundColor: ["#00E4FF", "#FF8383"],
      borderColor: ["#00E4FF", "#FF8383"],
      weight: 0,
    },
  ],
};

export default function Significant() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [significantImpactData, setSignificantImpactData] = useState<any>({});

  useEffect(() => {
    const getSignificantImpactData = () => {
      dispatch(dashboardAction({ apiAction: "significantImpact" }))
        .then((result: any) => {
          if (result?.payload?.status === 200) {
            setSignificantImpactData(result?.payload?.data?.data);
          }
        })
        .catch((err: any) => {
          // This console for debug the app if any error occurred in DEV
          console.log(err);
        });
    };
    getSignificantImpactData();
  }, []);

  const chartData = {
    //  labels: ["Significant impact", "Active students"],
    datasets: [
      {
        label: "# of Votes",
        data: [
          significantImpactData[
            Product.ProductCode() === THEME.SA
              ? "significantImpactPercentageSA"
              : "significantImpactPercentageGA"
          ],
        ],
        backgroundColor: ["#00E4FF", "#FF8383"],
        borderColor: ["#00E4FF", "#FF8383"],
        weight: 0,
      },
    ],
  };

  return (
    <div className="padding-y-10">
      <div className=" dashboard-heading padding-y-10 center padding-20">
        <div className="font-14 bolder">{t("significantImpact")}</div>
      </div>
      <div style={{ fontSize: "12px", textAlign: "center" }}>
        {dayjs().subtract(1, "year").format("MMMM YY")} to{" "}
        {dayjs().subtract(1, "month").format("MMMM YY")}
      </div>
      {Product.ProductCode() !== THEME.CRICO ? (
        <div className="position-relative center">
          <div className="doughnut-wrap ">
            <div className="doughnut-percentage">
              {Product.ProductCode() === THEME.SA
                ? significantImpactData["significantImpactPercentageSA"]
                : significantImpactData["significantImpactPercentageGA"]}
              %
            </div>
          </div>

          <div className=" doughnut-chart padding-up-15 padding-down-15">
            <Doughnut data={chartData} options={options} height={120} />
          </div>
        </div>
      ) : (
        <>
          <div className="coming-soon">Coming Soon</div>
        </>
      )}
    </div>
  );
}
